export default __webpack_public_path__ + "static/media/infographic_MSA.26376496.svg";